const initialState = require('./store/initial-state.js')
const gameControls = require('./store/game-controls.js')
const selectGlitchStickers = require('./store/select-glitch-stickers.js')
const moveGlitchStickers = require('./store/move-glitch-stickers.js')
const importPart = require('./store/import-part.js')
const toolbarselection = require('./store/toolbarselection.js')
const toolbarsort = require('./store/toolbarsort.js')
const inventoryNavigation = require('./store/inventory-navigation.js')
const inventoryPick = require('./store/inventory-pick.js')
const drag = require('./store/drag.js')
const load = require('./store/load.js')
const scratchVM = require('./store/scratch-vm.js')
const target = require('./store/target.js')
const input = require('./store/input.js')
const spriteTransforms = require('./store/sprite-transforms.js')
const history = require('./store/history.js')
const variables = require('./store/variables.js')
const mainMenu = require('./store/main-menu.js')
const highlight = require('./store/highlight.js')
const deselect = require('./store/deselect.js')
const glitchApplication = require('./store/glitch-application.js')
const scaffoldProjectBrowser = require('./store/scaffold-project-browser.js')
const documentEventListeners = require('./store/document-event-listeners.js')
const startingGlitches = require('./store/starting-glitches.js')
const glitchEditorOpen = require('./store/glitch-editor-open.js')
const glitchEditorSave = require('./store/glitch-editor-save.js')
const glitchEditorSelect = require('./store/glitch-editor-select.js')
const glitchEditorVariables = require('./store/glitch-editor-variables.js')
const glitchEditorLoadContent = require('./store/glitch-editor-load-content.js')
const loadScenes = require('./store/load-scenes.js')
const loadLevels = require('./store/load-levels.js')
const shareFromUrl = require('./store/share-from-url.js')
const importExport = require('./store/import-export.js')
const applyGlitchToAll = require('./store/apply-glitch-to-all.js')
const deleteAndDuplicateSprites =
  require('./store/delete-and-duplicate-sprites')
const fullscreen = require('./store/fullscreen.js')
module.exports = function store (givenState, emitter) {
  const state = Object.assign(givenState, initialState)
  documentEventListeners(state, emitter)
  gameControls(state, emitter)
  selectGlitchStickers(state, emitter)
  moveGlitchStickers(state, emitter)
  importPart(state, emitter)
  toolbarselection(state, emitter)
  toolbarsort(state, emitter)
  inventoryPick(state, emitter)
  inventoryNavigation(state, emitter)
  drag(state, emitter)
  load(state, emitter)
  scratchVM(state, emitter)
  target(state, emitter)
  input(state, emitter)
  spriteTransforms(state, emitter)
  history(state, emitter)
  variables(state, emitter)
  mainMenu(state, emitter)
  highlight(state, emitter)
  deselect(state, emitter)
  glitchApplication(state, emitter)
  scaffoldProjectBrowser(state, emitter)
  startingGlitches(state, emitter)
  glitchEditorOpen(state, emitter)
  glitchEditorSave(state, emitter)
  glitchEditorSelect(state, emitter)
  glitchEditorVariables(state, emitter)
  glitchEditorLoadContent(state, emitter)
  loadScenes(state, emitter)
  loadLevels(state, emitter)
  shareFromUrl(state, emitter)
  importExport(state, emitter)
  deleteAndDuplicateSprites(state, emitter)
  applyGlitchToAll(state, emitter)
  fullscreen(state, emitter)
}
